/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The IntegrationsphotonHealthPhotonHealthIntegration model module.
 * @module model/IntegrationsphotonHealthPhotonHealthIntegration
 * @version v0.3
 */
export default class IntegrationsphotonHealthPhotonHealthIntegration {
  /**
   * Constructs a new <code>IntegrationsphotonHealthPhotonHealthIntegration</code>.
   * @alias module:model/IntegrationsphotonHealthPhotonHealthIntegration
   * @class
   * @param m2mClientId {String} 
   * @param m2mClientSecret {String} 
   * @param spaClientId {String} 
   * @param spaClientSecret {String} 
   * @param organizationId {String} 
   */
  constructor(m2mClientId, m2mClientSecret, spaClientId, spaClientSecret, organizationId) {
    this.m2mClientId = m2mClientId;
    this.m2mClientSecret = m2mClientSecret;
    this.spaClientId = spaClientId;
    this.spaClientSecret = spaClientSecret;
    this.organizationId = organizationId;
  }

  /**
   * Constructs a <code>IntegrationsphotonHealthPhotonHealthIntegration</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsphotonHealthPhotonHealthIntegration} obj Optional instance to populate.
   * @return {module:model/IntegrationsphotonHealthPhotonHealthIntegration} The populated <code>IntegrationsphotonHealthPhotonHealthIntegration</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsphotonHealthPhotonHealthIntegration();
      if (data.hasOwnProperty('m2m_client_id'))
        obj.m2mClientId = ApiClient.convertToType(data['m2m_client_id'], 'String');
      if (data.hasOwnProperty('m2m_client_secret'))
        obj.m2mClientSecret = ApiClient.convertToType(data['m2m_client_secret'], 'String');
      if (data.hasOwnProperty('spa_client_id'))
        obj.spaClientId = ApiClient.convertToType(data['spa_client_id'], 'String');
      if (data.hasOwnProperty('spa_client_secret'))
        obj.spaClientSecret = ApiClient.convertToType(data['spa_client_secret'], 'String');
      if (data.hasOwnProperty('organization_id'))
        obj.organizationId = ApiClient.convertToType(data['organization_id'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} m2mClientId
 */
IntegrationsphotonHealthPhotonHealthIntegration.prototype.m2mClientId = undefined;

/**
 * @member {String} m2mClientSecret
 */
IntegrationsphotonHealthPhotonHealthIntegration.prototype.m2mClientSecret = undefined;

/**
 * @member {String} spaClientId
 */
IntegrationsphotonHealthPhotonHealthIntegration.prototype.spaClientId = undefined;

/**
 * @member {String} spaClientSecret
 */
IntegrationsphotonHealthPhotonHealthIntegration.prototype.spaClientSecret = undefined;

/**
 * @member {String} organizationId
 */
IntegrationsphotonHealthPhotonHealthIntegration.prototype.organizationId = undefined;

/**
 * @member {Boolean} enabled
 * @default true
 */
IntegrationsphotonHealthPhotonHealthIntegration.prototype.enabled = true;

